import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { BuildingService } from "../../data";
import * as buildingActions from '../actions/building.actions';
import { of } from "rxjs/observable/of";

@Injectable()
export class BuildingEffects {
  constructor(private actions$: Actions, private buildingService: BuildingService) { }

  @Effect()
  loadBuildings$ = this.actions$.ofType(buildingActions.BuildingActionTypes.LoadBuildings)
    .switchMap(() => {
      return this.buildingService.getBuildings()
        .map(list => new buildingActions.LoadBuildingsSuccess(list))
        .catch(error => of(new buildingActions.LoadBuildingsFail(error)));
    });

  @Effect()
  loadBuildingLevels$ = this.actions$.ofType(buildingActions.BuildingActionTypes.LoadBuildingLevels)
    .switchMap(() => {
      return this.buildingService.getBuildingLevels()
        .map(list => new buildingActions.LoadBuildingLevelsSuccess(list))
        .catch(error => of(new buildingActions.LoadBuildingLevelsFail(error)));
    });

  @Effect()
  loadBuildingUnits$ = this.actions$.ofType(buildingActions.BuildingActionTypes.LoadBuildingUnits)
    .map((action: buildingActions.LoadBuildingUnits) => action.payload)
    .switchMap(id => {
      return this.buildingService.getBuildingUnits(id.companyId, id.filterUnits)
        .map(list => new buildingActions.LoadBuildingUnitsSuccess(list))
        .catch(error => of(new buildingActions.LoadBuildingUnitsFail(error)));
    });

  @Effect()
  loadAllBuildingUnits$ = this.actions$.ofType(buildingActions.BuildingActionTypes.LoadAllBuildingUnits)
    .switchMap(() => {
      return this.buildingService.getAllBuildingUnits()
        .map(list => new buildingActions.LoadAllBuildingUnitsSuccess(list))
        .catch(error => of(new buildingActions.LoadAllBuildingUnitsFail(error)));
    });

  
}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/building.effects.ts